// test2229
(2229 && 0);
